import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-beae1ce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Silhouette of a person's head",
  src: "https://ionicframework.com/docs/img/demos/avatar.svg"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "primary" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Ricerca soci")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                name: "nome",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_searchbar, {
                    placeholder: "Nome",
                    "show-clear-button": "focus",
                    modelValue: $data.search.NOMER,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.search.NOMER) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ion_button, {
                    size: "default",
                    color: "primary",
                    id: "open-modal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: $setup.optionsOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                shape: "round",
                expand: "block",
                size: "default",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.searchUser())),
                style: {"margin":"15px"},
                disabled: $data.searching
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cerca ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              ($data.searching)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, { animated: true })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"80%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"60%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"30%"}
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, { animated: true })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"80%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"60%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"30%"}
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, { animated: true })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"80%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"60%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"30%"}
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, { animated: true })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"80%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"60%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"30%"}
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_skeleton_text, { animated: true })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"80%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"60%"}
                                })
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_ion_skeleton_text, {
                                  animated: true,
                                  style: {"width":"30%"}
                                })
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                    default: _withCtx(() => [
                      ($data.users !== null && $data.users.length === 0)
                        ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Nessun utente trovato")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            ($data.users && $data.users.length>0)
                              ? (_openBlock(), _createBlock(_component_ion_label, {
                                  key: 0,
                                  slot: "end"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($data.users.length) + " risultati", 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.users, (user) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: 'user_'+user.codaica
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_avatar, { slot: "start" }, {
                                    default: _withCtx(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, _toDisplayString(user.cognome) + " " + _toDisplayString(user.nome), 1),
                                      _createElementVNode("p", null, "Cod AICA " + _toDisplayString(user.codaica), 1),
                                      _createElementVNode("p", null, "Data iscrizione " + _toDisplayString(user.dataiscr), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ], 64))
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            ref: "modal",
            trigger: "open-modal",
            onWillDismiss: $options.onWillDismiss
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, { onClick: $options.resetParameters }, {
                            default: _withCtx(() => [
                              _createTextVNode("Resetta")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            strong: true,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.closeModal()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Chiudi")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, { class: "ion-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        type: "text",
                        label: "Cognome",
                        "label-placement": "stacked",
                        placeholder: "",
                        modelValue: $data.search.COGNOMER,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.search.COGNOMER) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        type: "text",
                        label: "Codice Fiscale",
                        "label-placement": "stacked",
                        placeholder: "",
                        modelValue: $data.search.CFISCR,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.search.CFISCR) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select, {
                        name: "sezione",
                        label: "Sezione territoriale",
                        "label-placement": "stacked",
                        modelValue: $data.search.SIGLASEZR,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.search.SIGLASEZR) = $event)),
                        labelPlacement: "floating"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sezioni, (sez) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              value: sez.code,
                              key: 'sez_'+sez.code
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(sez.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    shape: "round",
                    expand: "block",
                    size: "default",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.searchUser())),
                    style: {"margin":"15px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cerca ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onWillDismiss"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}